import React, { Component } from 'react';
import { withRouter } from '../../../../common/utils/NavigationWrapper';

import { ScatterPlot as FleetIcon } from '@mui/icons-material';

import { Button } from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';
import FleetsView from './FleetsView';
import {
  getFleets,
  saveFleet,
  deleteFleet,
  updateAllFleets,
  updateFleet,
} from './FleetsView.actions';
import Validators from '../../../../common/utils/Validators';
import Store from '../../../../redux/Store';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../../common/constants/Constants';
import Loading from '../../../../common/components/Loading/Loading';
import './FleetsView.css';
import { customFormatQuery } from '../QueryEditor/QueryEditor';

class FleetsViewContainer extends Component {
  constructor() {
    super();

    this.state = {
      fleetsList: [],
      showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
      newFleetName: '',
      errorMessageNewFleetName: '',
      isFetching: true,
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
    };
  }

  componentDidMount() {
    getFleets().then((res) => {
      this.setState({
        fleetsList: res,
        errorMessageNewFleetName: '',
        isFetching: false,
      });
    });
  }

  render() {
    return (
      <Loading condition={this.state.isFetching}>
        <Tile
          title="Fleets"
          TitleIcon={FleetIcon}
          helpTag="fleets_view"
          RightContent={
            <>
              <Button
                variant="contained"
                data-qa="qa-addNewFleet"
                className="u-ml-full"
                color="primary"
                onClick={() => this._openAddFleetDialogCallback('')}
              >
                Add fleet
              </Button>
              <Button
                variant="contained"
                data-qa="qa-updateAllFleet"
                className="u-ml-full"
                onClick={() => this._updateAllFleets()}
              >
                Update all
              </Button>
            </>
          }
        >
          <FleetsView
            fleetsList={this.state.fleetsList}
            onChangeCallback={this._onChangeNewFleet}
            showDialog={this.state.showDialog}
            errorFleetName={this.state.errorMessageNewFleetName}
            fleetName={this.state.newFleetName}
            isFetching={this.state.isFetching}
            onDeleteCallback={this._onDeleteFleet}
            onEditCallback={this._onEditFleet}
            onUpdateCallback={this._onUpdateFleet}
            onFleetRowSelected={this._onFleetRowSelected}
            showConfirmDialog={this.state.showConfirmDialog}
            messageToConfirm={this.state.messageToConfirm}
          />
        </Tile>
      </Loading>
    );
  }

  _onFleetRowSelected = (selectedFleet) => {
    const { navigate } = this.props;
    navigate(`/fleet-details/${selectedFleet.FleetId}`);
  };

  _onChangeNewFleet = (propertyName, value) => {
    this.setState((prevState) => ({
      newFleetName: value,
      errorMessageNewFleetName:
        prevState.newFleetName !== value
          ? this._getValidationErrorMessage(value)
          : prevState.errorMessageNewFleetName,
    }));
  };

  _onDeleteFleet = (event, fleetToDelete) => {
    event.stopPropagation();
    this.setState({
      messageToConfirm: `Are you sure you want to delete fleet "${fleetToDelete.Name}"?`,
      showConfirmDialog: {
        title: `Delete fleet ${fleetToDelete.Name}`,
        show: true,
        action: () => this._onConfirmDeleteFleet(fleetToDelete),
        cancel: this._onCanceldeleteFleet,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmDeleteFleet = (fleetToDelete) => {
    if (fleetToDelete) {
      this.setState({ showConfirmDialog: { disableMainAction: true } });

      deleteFleet(fleetToDelete.FleetId)
        .then(() => getFleets())
        .then((resp) => {
          this.setState(
            {
              fleetsList: resp,
              messageToConfirm: '',
              showConfirmDialog: {
                show: false,
                disableMainAction: false,
                action: () => {},
                cancel: () => {},
              },
            },
            () => this._showSuccesMessage('Successfully deleted.')
          );
        })
        .catch((err) => this._showFailMessage('Error occured'));
    }
  };

  _onCanceldeleteFleet = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
      },
    });
  };

  _onEditFleet = (event, fleetToEdit) => {
    const { navigate } = this.props;
    navigate(`/edit-fleet/${fleetToEdit.FleetId}`);
    event.stopPropagation();
  };

  _onUpdateFleet = (event, fleetToUpdate) => {
    updateFleet(fleetToUpdate.FleetId)
      .then(() => getFleets())
      .then((resp) => {
        this.setState(
          {
            fleetsList: resp,
            messageToConfirm: '',
            showConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
          },
          () => this._showSuccesMessage('Fleet successfully updated ' + fleetToUpdate.Name)
        );
      })
      .catch((err) => this._showFailMessage('Update not successfull. Please try again later'));

    event.stopPropagation();
  };

  _addFleet = () => {
    if (this.state.newFleetName && !this._existingFleetValidation(this.state.newFleetName)) {
      this.setState({ isFetching: true });
      saveFleet({
        Name: this.state.newFleetName,
        Query: customFormatQuery(
          JSON.stringify({
            combinator: 'and',
            id: 0.99078931967614725,
            rules: [
              {
                field: 'SerialNumber',
                id: 0.19078931967614725,
                operator: 'not_null',
                value: null,
              },
            ],
          })
        ),
      })
        .then((res) => updateFleet(res.body.FleetId))
        .then(() => getFleets())
        .then((res) => {
          this.setState(
            {
              fleetsList: res,
              showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
              isFetching: false,
            },
            () => this._showSuccesMessage('Successfully added.')
          );
        })
        .catch((err) => {
          this.setState({ isFetching: true }, () => this._showFailMessage('Error occured'));
        });
    } else {
      this._showFailMessage('Empty fleet name or similar fleet name already exists!');
    }
  };

  _updateAllFleets = () => {
    updateAllFleets()
      .then(() => getFleets())
      .then((res) => {
        this.setState(
          {
            fleetsList: res,
            showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
            isFetching: false,
          },
          () => this._showSuccesMessage('Successfully updated all fleets.')
        );
      })
      .catch((err) => {
        this.setState({ isFetching: false }, () => this._showFailMessage('Error occured'));
      });
  };

  _cancelCreatingFleet = () => {
    this.setState({
      showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
      errorMessageNewFleetName: '',
    });
  };

  _openAddFleetDialogCallback = () => {
    this.setState({
      showDialog: {
        show: true,
        title: 'Add a new fleet',
        action: this._addFleet,
        cancel: this._cancelCreatingFleet,
      },
    });
  };

  _getValidationErrorMessage = (value) => {
    let validationMessage = '';
    if (value && value.trim() === '') {
      validationMessage = 'Name cannot consist only of white spaces';
    }
    if (!Validators.validateStringBetweenRange(value, 1, 200)) {
      validationMessage = 'Enter an alphanumeric value between 1 and 200 characters';
    }
    return validationMessage;
  };

  _existingFleetValidation = (value) => {
    for (let fleet of this.state.fleetsList) {
      if (value.toLowerCase().replace(/\s/g, '') === fleet.Name.toLowerCase().replace(/\s/g, '')) {
        return true;
      }
    }
  };

  _showSuccesMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }

  _showFailMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: theMessage,
      })
    );
  }
}

export default withRouter(FleetsViewContainer);
